import { API_URL } from "../../../../utils/constant";

const BillFormatA5Page = ({ companyData, data, withHeader = true }) => {
  const formatDate = (dateString) => {
    if (!dateString) return '';
    const date = new Date(dateString);
    return date.toLocaleDateString('en-GB', { day: '2-digit', month: '2-digit', year: 'numeric' });
  };

  const formatCurrency = (amount) => {
    return (parseFloat(amount) || 0).toFixed(2);
  };

  const isLooseProduct = (item) => {
    if (!item) return false;
    return (
      item.is_loose === true ||
      item.is_loose === 1 ||
      item.is_loose === 'true' ||
      item.is_loose === '1' ||
      !!item.dispense_info ||
      (typeof item.brand_name === 'string' && item.brand_name.toUpperCase().includes('LOOSE')) ||
      (typeof item.brand === 'string' && item.brand.toUpperCase().includes('LOOSE')) ||
      (typeof item.Brand?.name === 'string' && item.Brand.name.toUpperCase().includes('LOOSE')) ||
      (typeof item.product_name === 'string' && (
        item.product_name.includes('D/W -') ||
        item.product_name.includes('(Globules -') ||
        item.product_name.includes('(Liquid -') ||
        item.product_name.includes('(Puria -') ||
        item.product_name.includes('(Trituration') ||
        item.product_name.includes('(Mother Tincture') ||
        item.product_name.includes('(Biochemic')
      ))
    );
  };

  const getItemUnitCountAndPrice = (item) => {
    if (!isLooseProduct(item)) {
      return {
        isSubUnitItem: false,
        subUnits: 1,
        totalQty: parseFloat(item.qty) || 0,
        singlePrice: parseFloat(item.price) || 0
      };
    }

    const rawQty = parseFloat(item.qty !== undefined && item.qty !== null ? item.qty : (item.billed_qty !== undefined ? item.billed_qty : 1));
    const baseQty = isNaN(rawQty) || rawQty <= 0 ? 1 : rawQty;

    let subUnits = 0;
    const info = item.dispense_info || {};
    const rawProductName = String(item.product_name || item.name || '');

    if (info.puriaCount && parseFloat(info.puriaCount) > 1) {
      subUnits = parseFloat(info.puriaCount);
    } else if (info.puriaQty && parseFloat(info.puriaQty) > 1) {
      subUnits = parseFloat(info.puriaQty);
    } else if (info.salesUnit === 'PURIA' && parseFloat(info.salesSize) > 1) {
      subUnits = parseFloat(info.salesSize);
    } else {
      const match = rawProductName.match(/(?:x\s*)?(\d+)\s*Purias?/i);
      if (match && parseFloat(match[1]) > 1) {
        subUnits = parseFloat(match[1]);
      }
    }

    if (subUnits > 1) {
      const totalUnits = baseQty * subUnits;
      let singlePrice = 0;
      if (info.unitSellingPrice && parseFloat(info.unitSellingPrice) > 0) {
        singlePrice = parseFloat(info.unitSellingPrice);
      } else {
        const fullPrice = parseFloat(
          item.price !== undefined && item.price !== null
            ? item.price
            : (item.sale_cost !== undefined && item.sale_cost !== null
                ? item.sale_cost
                : (info.sellingPrice || item.amount || 0))
        ) || 0;
        singlePrice = totalUnits > 0 ? (fullPrice / totalUnits) : fullPrice;
      }

      return {
        isSubUnitItem: true,
        subUnits,
        totalQty: totalUnits,
        singlePrice
      };
    }

    const price = parseFloat(
      item.price !== undefined && item.price !== null
        ? item.price
        : (item.sale_cost !== undefined && item.sale_cost !== null
            ? item.sale_cost
            : (info.sellingPrice !== undefined && info.sellingPrice !== null
                ? info.sellingPrice
                : (baseQty > 0 && item.amount ? item.amount / baseQty : 0)))
    ) || 0;

    return {
      isSubUnitItem: false,
      subUnits: 1,
      totalQty: baseQty,
      singlePrice: price
    };
  };

  const calculateTotals = () => {
    let originalInclusiveSubtotal = 0;

    const lineCalculations = (data.product_data || []).map(item => {
      const isLoose = isLooseProduct(item);
      const unitInfo = getItemUnitCountAndPrice(item);
      const totalItemQty = unitInfo.totalQty;
      const isFree = item.is_free === 1 || item.is_free === true || item.is_free === '1' || item.is_free === 'true' || (totalItemQty > 0 && parseFloat(item.free_qty || 0) >= totalItemQty);
      const freeQty = isFree ? totalItemQty : Math.min(totalItemQty, parseFloat(item.free_qty || 0));
      const billedQty = isFree ? 0 : Math.max(0, totalItemQty - freeQty);

      const gstPercent = parseFloat(item.gst) || 0;
      const price = unitInfo.singlePrice;
      const isInclusive = isLoose ? (item.gst_included !== false && item.gst_included !== 0 && item.gst_included !== '0') : !!item.gst_included;
      const inclusivePrice = isInclusive ? price : price * (1 + gstPercent / 100);
      const billedGross = inclusivePrice * billedQty;

      let itemDisc = 0;
      if (!isFree && item.discount_amount !== undefined && item.discount_amount !== null && parseFloat(item.discount_amount) > 0) {
        itemDisc = parseFloat(item.discount_amount);
      } else if (!isFree && parseFloat(item.discount_value || 0) > 0) {
        if (item.discount_type === 'fixed') {
          itemDisc = Math.min(parseFloat(item.discount_value), billedGross);
        } else {
          itemDisc = (billedGross * parseFloat(item.discount_value)) / 100;
        }
      }

      const lineNet = isFree ? 0 : Math.max(0, billedGross - itemDisc);
      originalInclusiveSubtotal += lineNet;

      return {
        ...item,
        isFree,
        isLoose,
        totalItemQty,
        freeQty,
        billedQty,
        gstPercent,
        price,
        inclusivePrice,
        billedGross,
        itemDisc,
        lineNet
      };
    });

    const discountAmount = parseFloat(data.discountAmount || data.discount_amount || 0) || 0;
    const discountedInclusiveSubtotal = Math.max(originalInclusiveSubtotal - discountAmount, 0);

    let totalTax = 0;
    let taxableAmount = 0;

    const processedItems = lineCalculations.map(item => {
      const itemProportion = originalInclusiveSubtotal > 0 ? item.lineNet / originalInclusiveSubtotal : 0;
      const itemFinalInclusive = discountedInclusiveSubtotal * itemProportion;

      const itemTaxAmount = itemFinalInclusive > 0 ? (itemFinalInclusive - (itemFinalInclusive / (1 + item.gstPercent / 100))) : 0;
      const itemTaxableAmount = itemFinalInclusive - itemTaxAmount;

      taxableAmount += itemTaxableAmount;
      totalTax += itemTaxAmount;

      return {
        ...item,
        price: item.price,
        itemDiscountedTotal: itemFinalInclusive,
        itemTaxableAmount,
        itemTaxAmount,
        itemDiscount: item.itemDisc
      };
    });

    return {
      originalSubtotal: originalInclusiveSubtotal,
      discountedSubtotal: discountedInclusiveSubtotal,
      taxableAmount,
      totalTax,
      discountAmount,
      processedItems
    };
  };

  const { originalSubtotal, discountedSubtotal, taxableAmount, totalTax, discountAmount, processedItems } = calculateTotals();

  const displayTotalTax = parseFloat((totalTax).toFixed(2));
  const displayTaxableAmount = Math.max(0, discountedSubtotal - displayTotalTax);
  const grandTotalRaw = discountedSubtotal;
  const grandTotal = Math.round(grandTotalRaw);
  const totalQty = (data.product_data || []).reduce((sum, i) => {
    const unitInfo = getItemUnitCountAndPrice(i);
    return sum + (unitInfo.totalQty || 0);
  }, 0);

  const numberToWords = (num) => {
    const ones = ['', 'one', 'two', 'three', 'four', 'five', 'six', 'seven', 'eight', 'nine', 'ten', 'eleven', 'twelve', 'thirteen', 'fourteen', 'fifteen', 'sixteen', 'seventeen', 'eighteen', 'nineteen'];
    const tens = ['', '', 'twenty', 'thirty', 'forty', 'fifty', 'sixty', 'seventy', 'eighty', 'ninety'];

    const convert = (n) => {
      if (n === 0) return 'zero';
      if (n < 20) return ones[n];
      if (n < 100) return tens[Math.floor(n / 10)] + (n % 10 ? ' ' + ones[n % 10] : '');
      if (n < 1000) return ones[Math.floor(n / 100)] + ' hundred' + (n % 100 ? ' and ' + convert(n % 100) : '');
      if (n < 100000) return convert(Math.floor(n / 1000)) + ' thousand' + (n % 1000 ? ' ' + convert(n % 1000) : '');
      if (n < 10000000) return convert(Math.floor(n / 100000)) + ' lakh' + (n % 100000 ? ' ' + convert(n % 100000) : '');
      return convert(Math.floor(n / 10000000)) + ' crore' + (n % 10000000 ? ' ' + convert(n % 10000000) : '');
    };

    const rupees = Math.floor(num || 0);
    if (rupees === 0) return 'ZERO ONLY';
    return (convert(rupees) + ' only').toUpperCase();
  };

  const companyName = companyData?.company_name || companyData?.name || 'JNM Homoeo Sadan';

  // Pagination Chunking: 8 items per page for A5
  const ITEMS_PER_PAGE = 8;
  const itemChunks = [];
  if (processedItems.length === 0) {
    itemChunks.push([]);
  } else {
    for (let i = 0; i < processedItems.length; i += ITEMS_PER_PAGE) {
      itemChunks.push(processedItems.slice(i, i + ITEMS_PER_PAGE));
    }
  }
  const totalPages = itemChunks.length;

  const getItemVolume = (item) => {
    // Pack is blank for JNM loose products (only for sealed products)
    if (isLooseProduct(item)) return '';

    if (item.volume && String(item.volume).trim()) return String(item.volume).trim();
    if (item.volumn && String(item.volumn).trim()) return String(item.volumn).trim();
    if (item.pack && String(item.pack).trim()) return String(item.pack).trim();
    if (item.size && String(item.size).trim()) return String(item.size).trim();

    if (item.variant_name && /\b\d+\s*(?:ml|gm|gms|tab|tabs|tablets|cap|caps|capsules|kg|vials|pcs|l|oz)\b/i.test(item.variant_name)) {
      const vMatch = item.variant_name.match(/\b\d+\s*(?:ml|gm|gms|tab|tabs|tablets|cap|caps|capsules|kg|vials|pcs|l|oz)\b/i);
      if (vMatch) return vMatch[0].trim();
    }

    const fullName = [item.product_name, item.name, item.item_name, item.description, item.Product?.name].filter(Boolean).join(' ');
    const match = fullName.match(/\b(\d+\s*(?:ml|gm|gms|tab|tabs|tablets|cap|caps|capsules|kg|vials|pcs|l|oz))\b/i);
    if (match) return match[1].trim();

    if (item.AvailableVariant?.volume) return String(item.AvailableVariant.volume).trim();

    return (item.unit || '').trim();
  };

  const getFormattedProductName = (item) => {
    const rawProductName = (item.product_name || item.name || item.Product?.name || item.product?.name || item.item_name || '').replace(/-+$/, '').trim();

    if (!isLooseProduct(item)) {
      const brandName = (item.brand_name || item.brand?.name || (typeof item.brand === 'string' ? item.brand : '') || item.Brand?.name || item.Product?.Brand?.name || item.product?.Brand?.name || item.Product?.brand || item.product?.brand || '').trim();
      return brandName && !rawProductName.toLowerCase().includes(brandName.toLowerCase())
        ? `${rawProductName} - ${brandName}`
        : rawProductName;
    }

    // JNM LOOSE: only show medicine name with selected dose (e.g. "ARNICA MONTANA (30) - D/W - 120ML")
    let doseLabel = '';
    const info = item.dispense_info || {};
    const cat = info.category || '';

    if (cat === 'DW_DOSE' || /\bD\/?W\b/i.test(rawProductName)) {
      let sizeVal = parseFloat(info.salesSize || 0);
      if (!sizeVal && info.doseCount) {
        const m = String(info.doseCount).match(/(\d+)\s*ml/i);
        if (m) sizeVal = parseFloat(m[1]);
      }
      if (!sizeVal) {
        const m = rawProductName.match(/\bD\/?W\s*-\s*(\d+)\s*ml/i) || rawProductName.match(/(\d+)\s*ml/i);
        if (m) sizeVal = parseFloat(m[1]);
      }
      if (!sizeVal) sizeVal = 30;
      doseLabel = `D/W - ${sizeVal}ML`;
    } else if (cat === 'MEDICATED_GLOBULES' || /globules/i.test(rawProductName)) {
      let sizeVal = parseFloat(info.salesSize || 0);
      if (!sizeVal) {
        const m = rawProductName.match(/globules\s*-\s*(\d+(?:\.\d+)?)\s*(?:gm|g)?/i);
        if (m) sizeVal = parseFloat(m[1]);
      }
      doseLabel = `Globules - ${sizeVal || 10}GM`;
    } else if (cat === 'DILUTION_LIQUID' || /liquid/i.test(rawProductName)) {
      let sizeVal = parseFloat(info.salesSize || 0);
      if (!sizeVal) {
        const m = rawProductName.match(/liquid\s*-\s*(\d+(?:\.\d+)?)\s*ml/i);
        if (m) sizeVal = parseFloat(m[1]);
      }
      doseLabel = `Liquid - ${sizeVal || 30}ML`;
    } else if (cat === 'MOTHER_TINCTURE' || /mother tincture/i.test(rawProductName)) {
      let sizeVal = parseFloat(info.salesSize || 0);
      if (!sizeVal) {
        const m = rawProductName.match(/mother tincture\s*-\s*(\d+(?:\.\d+)?)\s*ml/i);
        if (m) sizeVal = parseFloat(m[1]);
      }
      doseLabel = `Mother Tincture - ${sizeVal || 30}ML`;
    } else if (cat === 'BIOCHEMIC' || /biochemic/i.test(rawProductName)) {
      let sizeVal = parseFloat(info.salesSize || 0);
      if (!sizeVal) {
        const m = rawProductName.match(/biochemic\s*-\s*(\d+(?:\.\d+)?)\s*gm/i);
        if (m) sizeVal = parseFloat(m[1]);
      }
      doseLabel = `Biochemic - ${sizeVal || 20}GM`;
    } else if (cat === 'SAC_LAC_DOSE' || /puria/i.test(rawProductName)) {
      doseLabel = 'Puria';
    } else if (cat === 'TRITURATION' || /trituration/i.test(rawProductName)) {
      const isPuria = info.dispensingForm === 'PURIA' || info.salesUnit === 'PURIA' || /puria/i.test(rawProductName);
      if (isPuria) {
        doseLabel = 'Trituration - Puria';
      } else {
        const sizeVal = parseFloat(info.salesSize || 0) || 20;
        doseLabel = `Trituration - ${sizeVal}GM`;
      }
    } else if (info.salesSize && info.salesUnit) {
      doseLabel = `${info.medicineType ? `${info.medicineType} - ` : ''}${parseFloat(info.salesSize)}${info.salesUnit.toUpperCase()}`;
    }

    let baseName = rawProductName
      .replace(/\s*-\s*JNM\s+LOOSE\b/gi, '')
      .replace(/\bJNM\s+LOOSE\b/gi, '')
      .replace(/\s*\((?:D\/W|Liquid|Globules|Puria|Trituration|Mother Tincture|Biochemic)[\s\S]*$/gi, '')
      .replace(/\s*-\s*(?:D\/W|Liquid|Globules|Puria|Trituration|Mother Tincture|Biochemic)[\s\S]*$/gi, '')
      .replace(/(?:x\s*)?\b\d+\s*Purias?\b/gi, '')
      .replace(/\s*-\s*$/, '')
      .trim();

    if (!baseName) {
      baseName = (item.Product?.name || item.name || 'Medicine').replace(/\s*-\s*JNM\s+LOOSE\b/gi, '').trim();
    }

    if (doseLabel) {
      return `${baseName} - ${doseLabel}`;
    }
    return baseName;
  };

  const getItemHsn = (item) => {
    if (item.hsn_sac && String(item.hsn_sac).trim()) return String(item.hsn_sac).trim();
    if (item.hsn_code && String(item.hsn_code).trim()) return String(item.hsn_code).trim();
    if (item.hsn && String(item.hsn).trim()) return String(item.hsn).trim();
    if (item.hsnCode && String(item.hsnCode).trim()) return String(item.hsnCode).trim();
    if (item.hsn_no && String(item.hsn_no).trim()) return String(item.hsn_no).trim();
    if (item.taxes?.hsn_code && String(item.taxes.hsn_code).trim()) return String(item.taxes.hsn_code).trim();
    if (item.taxes?.hsn_sac && String(item.taxes.hsn_sac).trim()) return String(item.taxes.hsn_sac).trim();
    if (item.tax?.hsn_code && String(item.tax.hsn_code).trim()) return String(item.tax.hsn_code).trim();
    if (item.Product?.hsn_sac && String(item.Product.hsn_sac).trim()) return String(item.Product.hsn_sac).trim();
    if (item.Product?.hsn_code && String(item.Product.hsn_code).trim()) return String(item.Product.hsn_code).trim();
    if (item.FinalCategory?.hsn_code && String(item.FinalCategory.hsn_code).trim()) return String(item.FinalCategory.hsn_code).trim();
    if (item.RawCategory?.hsn_code && String(item.RawCategory.hsn_code).trim()) return String(item.RawCategory.hsn_code).trim();
    if (item.category?.hsn_code && String(item.category.hsn_code).trim()) return String(item.category.hsn_code).trim();
    // Default fallback for medicine products if HSN is missing in past records
    return '30049014';
  };

  const MIN_ROWS = 6;

  const pagesHtml = itemChunks.map((chunk, pageIndex) => {
    const isLastPage = pageIndex === totalPages - 1;
    const startIndex = pageIndex * ITEMS_PER_PAGE;
    const emptyCount = Math.max(0, MIN_ROWS - chunk.length);

    const chunkItemsHtml = chunk.map((item, index) => {
      const globalIndex = startIndex + index + 1;
      const cgstRate = (parseFloat(item.gst || 0) / 2).toFixed(2);
      const sgstRate = (parseFloat(item.gst || 0) / 2).toFixed(2);
      const cgstAmount = item.itemTaxAmount / 2;
      const sgstAmount = item.itemTaxAmount / 2;
      const isFree = item.isFree || false;
      const billedQty = item.billedQty !== undefined ? item.billedQty : (isFree ? 0 : Math.max(0, (parseFloat(item.qty) || 0) - (parseFloat(item.free_qty) || 0)));
      const singleRate = billedQty > 0
        ? (item.itemTaxableAmount / billedQty)
        : (item.inclusivePrice > 0 ? (item.inclusivePrice / (1 + (item.gstPercent || 0) / 100)) : 0);
      const itemTotal = item.itemTaxableAmount + item.itemTaxAmount;
      const batchNo = item.batch_no || '';
      const productName = getFormattedProductName(item);
      const displayQtyVal = item.totalItemQty !== undefined ? item.totalItemQty : (parseFloat(item.qty) || 0);

      const qtyDisplay = isFree
        ? `${displayQtyVal} (FREE)`
        : (item.free_qty > 0 ? `${displayQtyVal} (${billedQty}+${item.free_qty}F)` : displayQtyVal);

      return `
        <tr>
          <td class="cell c">${globalIndex}</td>
          <td class="cell l" style="padding-left:4px;">${productName}</td>
          <td class="cell c">${getItemHsn(item)}</td>
          <td class="cell c">${getItemVolume(item)}</td>
          <td class="cell c">${batchNo}</td>
          <td class="cell r">${formatCurrency(singleRate)}</td>
          <td class="cell c" style="font-weight:bold;">${qtyDisplay}</td>
          <td class="cell r">${formatCurrency(item.itemTaxableAmount)}</td>
          <td class="cell c">${cgstRate}</td>
          <td class="cell r">${formatCurrency(cgstAmount)}</td>
          <td class="cell c">${sgstRate}</td>
          <td class="cell r">${formatCurrency(sgstAmount)}</td>
          <td class="cell r" style="font-weight:bold;">${formatCurrency(itemTotal)}</td>
        </tr>`;
    }).join('');

    const emptyRowsHtml = Array(emptyCount).fill(`
        <tr>
          <td class="cell">&nbsp;</td><td class="cell">&nbsp;</td><td class="cell">&nbsp;</td>
          <td class="cell">&nbsp;</td><td class="cell">&nbsp;</td><td class="cell">&nbsp;</td>
          <td class="cell">&nbsp;</td><td class="cell">&nbsp;</td><td class="cell">&nbsp;</td>
          <td class="cell">&nbsp;</td><td class="cell">&nbsp;</td><td class="cell">&nbsp;</td>
          <td class="cell">&nbsp;</td>
        </tr>`).join('');

    return `
        <div class="page" style="${pageIndex < totalPages - 1 ? 'page-break-after: always; margin-bottom: 20px;' : ''}">

          <!-- TOP LEFT HEADER (CUSTOMER & INVOICE META) -->
          <div class="top-left-header">
            <div class="customer-name">${data.Customer?.name || 'Cash Customer'}</div>
            ${data.Customer?.phone ? `<div class="customer-phone">Mob: ${data.Customer.phone}</div>` : ''}
            <div class="inv-meta">
              Inv: <strong>${data.bill_no}</strong> | Date: <strong>${formatDate(data.createdAt)}</strong>
              ${totalPages > 1 ? ` <span style="font-size:7pt; color:#666;">(Page ${pageIndex + 1} of ${totalPages})</span>` : ''}
            </div>
          </div>

          <!-- TOP SPACER -->
          <div class="top-spacer"></div>

          <!-- ITEMS TABLE -->
          <table class="items-tbl">
            <thead>
              <tr>
                <th rowspan="2" style="width:4%;">SL .</th>
                <th rowspan="2" style="width:24%; text-align:left;">NAME OF MEDICINE</th>
                <th rowspan="2" style="width:8%;">HSN CODE</th>
                <th rowspan="2" style="width:6%;">PACK</th>
                <th rowspan="2" style="width:6%;">BATCH</th>
                <th rowspan="2" style="width:7%;">RATE</th>
                <th rowspan="2" style="width:5%;">QTY</th>
                <th rowspan="2" style="width:8%;">PRICE</th>
                <th colspan="2" style="width:11%;">CGST</th>
                <th colspan="2" style="width:11%;">SGST</th>
                <th rowspan="2" style="width:10%;">AMOUNT</th>
              </tr>
              <tr>
                <th style="width:4%;">%</th>
                <th style="width:7%;">Amt</th>
                <th style="width:4%;">%</th>
                <th style="width:7%;">Amt</th>
              </tr>
            </thead>
            <tbody>
              ${chunkItemsHtml}
              ${emptyRowsHtml}
            </tbody>
          </table>

          ${isLastPage ? `
          <!-- TOTALS & AMOUNT IN WORDS (ONLY ON LAST PAGE) -->
          <div class="totals-area">
            <div class="words-block">
              <div><strong>Total Qty: ${totalQty} Pcs</strong> &nbsp;&nbsp; <strong>Total: ₹${formatCurrency(grandTotalRaw)}</strong></div>
              <div style="margin-top:3px;"><strong>Rs. in words:</strong> RUPEES ${numberToWords(grandTotal)}</div>
              <div style="margin-top:3px; font-size:6.5pt; color:#555;">
                Prepared by: ${data.salesExecutive || 'Admin'} | Mode: ${data.mode_of_payment ? data.mode_of_payment.toUpperCase() : 'CASH'}
              </div>
              <div style="margin-top:4px; font-size:6.5pt; font-weight:bold; color:#333; line-height:1.3;">
                Goods Once Sold not returnable.<br>
                Check the balance & medicine before leaving the counter.<br>
                Open All 7 Days (Mon-Sat: 9AM to 9PM, Sun: 10AM to 5PM)
              </div>
            </div>
            <div class="summary-block">
              <div>Taxable: <strong>₹${formatCurrency(displayTaxableAmount)}</strong></div>
              <div>CGST: <strong>₹${formatCurrency(totalTax / 2)}</strong></div>
              <div>SGST: <strong>₹${formatCurrency(totalTax / 2)}</strong></div>
              ${discountAmount > 0 ? `<div>Discount: <strong>-₹${formatCurrency(discountAmount)}</strong></div>` : ''}
              <div class="grand">Grand Total: ₹${formatCurrency(grandTotal)}</div>
              <div class="sign-box">
                <div style="font-weight:bold; font-size:7.5pt; color:#000;">For ${companyName}</div>
                <div style="margin-top:16px; font-weight:bold; font-size:7.5pt; color:#000; border-top:1px dashed #333; display:inline-block; padding-top:2px;">
                  Authorised Signatory
                </div>
              </div>
            </div>
          </div>` : `
          <!-- INTERMEDIATE PAGE FOOTER -->
          <div style="position: absolute; bottom: 15px; right: 15px; font-size: 7.5pt; font-weight: bold; color: #6B1C23;">
            Continued on Page ${pageIndex + 2}...
          </div>`}

        </div>`;
  }).join('');

  return `
    <!DOCTYPE html>
    <html>
      <head>
        <title>Tax Invoice - A5 Retail</title>
        <style>
          @page { size: A5 landscape; margin: 0; }
          * { margin: 0; padding: 0; box-sizing: border-box; }
          body {
            font-family: Arial, 'Helvetica Neue', Helvetica, sans-serif;
            font-size: 8pt;
            color: #000;
            padding: 5px;
            -webkit-print-color-adjust: exact !important;
            print-color-adjust: exact !important;
          }

          .page {
            width: calc(210mm - 10px);
            height: calc(148mm - 10px);
            background: ${withHeader ? "url('/bg_invoice_page1.png') no-repeat center top / 100% 100% #FDF5E6" : "transparent"};
            position: relative;
            overflow: hidden;
            padding: 0 10px;
            box-sizing: border-box;
          }

          /* TOP LEFT CUSTOMER & INVOICE HEADER */
          .top-left-header {
            position: absolute;
            top: 32px;
            left: 40px;
            z-index: 10;
            line-height: 1.3;
          }
          .customer-name {
            font-weight: bold;
            font-size: 9pt;
            color: #6B1C23;
          }
          .customer-phone {
            font-size: 7.5pt;
            color: #333;
          }
          .inv-meta {
            font-size: 7.5pt;
            color: #333;
            margin-top: 2px;
          }

          /* TOP SPACER (matches background header position) */
          .top-spacer {
            height: 33mm;
          }

          /* ITEMS TABLE */
          .items-tbl {
            width: 100%;
            border-collapse: collapse;
            margin-top: 2px;
          }
          .items-tbl th {
            font-size: 7.5pt;
            font-weight: bold;
            color: #000;
            padding: 3px 2px;
            border: 1px solid #000;
            text-align: center;
            background: rgba(255, 255, 255, 0.4);
          }
          .items-tbl td {
            font-size: 7.5pt;
            padding: 2px 3px;
            border: 1px solid #000;
            height: 16px;
            vertical-align: middle;
          }
          .c { text-align: center; }
          .l { text-align: left; }
          .r { text-align: right; }

          /* TOTALS & WORDS AREA */
          .totals-area {
            margin-top: 6px;
            width: 100%;
            display: flex;
            justify-content: space-between;
            align-items: flex-start;
          }
          .words-block {
            width: 55%;
            font-size: 7pt;
            line-height: 1.35;
          }
          .summary-block {
            width: 42%;
            text-align: right;
            font-size: 7.5pt;
            line-height: 1.35;
          }
          .summary-block .grand {
            font-size: 9.5pt;
            font-weight: bold;
            color: #6B1C23;
            margin-top: 2px;
            padding-top: 2px;
            border-top: 1px solid #000;
          }
          .sign-box {
            margin-top: 8px;
            text-align: right;
          }
        </style>
      </head>
      <body>
        ${pagesHtml}
      </body>
    </html>`;
};

export default BillFormatA5Page;
